import { lazy } from 'react'
import { Navigate, RouteObject } from 'react-router'

const PrivateLayout = lazy(() => import('@/layout'))
const Clients = lazy(() => import('@/views/Clients'))
const Credentials = lazy(() => import('@/views/Credentials'))
const ClientStatus = lazy(() => import('@/views/ClientStatus'))
const DomainVars = lazy(() => import('@/views/DomainVars'))
const DomainVarValues = lazy(() => import('@/views/DomainVarValues'))
const Domains = lazy(() => import('@/views/Domains'))
const ErrorPage = lazy(() => import('@/views/ErrorPage'))
const Login = lazy(() => import('@/views/Login'))
const Roles = lazy(() => import('@/views/Roles'))
const UserPermissions = lazy(() => import('@/views/UserPermissions'))
const Users = lazy(() => import('@/views/Users'))

import { PrivateRouteUrls, PublicRouteUrls } from './constants/routes-urls'

export const PUBLIC_ROUTES_CONTENT: RouteObject[] = [
  {
    path: PublicRouteUrls.LOGIN,
    element: <Login />
  }
]

export const PRIVATE_ROUTES_CONTENT: RouteObject[] = [
  {
    path: '/',
    element: <PrivateLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Navigate to={PrivateRouteUrls.DOMAINS} replace />
      },
      {
        path: PrivateRouteUrls.USERS,
        element: <Users />
      },
      {
        path: PrivateRouteUrls.USER_PERMISSIONS,
        element: <UserPermissions />
      },
      {
        path: PrivateRouteUrls.DOMAINS,
        element: <Domains />
      },
      {
        path: PrivateRouteUrls.DOMAIN_VARS,
        element: <DomainVars />
      },
      {
        path: PrivateRouteUrls.DOMAIN_VAR_VALUES,
        element: <DomainVarValues />
      },
      {
        path: PrivateRouteUrls.CLIENTS,
        element: <Clients />
      },
      {
        path: PrivateRouteUrls.ROLES,
        element: <Roles />
      },
      {
        path: PrivateRouteUrls.CREDENTIALS,
        element: <Credentials />
      },
      {
        path: PrivateRouteUrls.CLIENT_STATUS,
        element: <ClientStatus />
      },
      {
        path: '/test1',
        element: <>TEST1</>
      }
    ]
  }
]
